import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import useExecuteInlineScript from '../../hooks/useExecuteInlineScript';

/*eslint-disable react/no-danger*/

const FormBusy = ({ content }) => {
  const containerRef = useRef(null);
  useExecuteInlineScript(containerRef, content);
  return (
    <div className="ltFormBusySpinner">
      <div className="spin">
        <div className="inner" />
      </div>
      <div ref={containerRef} dangerouslySetInnerHTML={{ __html: content }} />
    </div>
  );
};

FormBusy.propTypes = {
  content: PropTypes.string,
};
/*eslint-enable */

export default FormBusy;
